import React from 'react';
import { observer } from '../../../shared/observer';

// Пользовательские дополнительные поля заказа.
// types: string, text, select, boolean.
class AdditionalFieldsView extends React.Component {
  setVal = (i, val) => {
    const list = (this.props.order.fieldsToUpdateOrder.additional_fields_collected || []).map((f, idx) => (
      idx === i ? Object.assign({}, f, { value: val }) : f
    ));
    this.props.order.setFieldsToUpdateOrder({ additional_fields_collected: list });
  };

  render() {
    const fields = this.props.order.fieldsToUpdateOrder.additional_fields_collected
      || (this.props.order.order && this.props.order.order.additional_fields_collected)
      || [];
    if (!fields.length) return null;

    return (
      <section className="ng-checkout__section">
        <label>Дополнительно</label>
        {fields.map((f, i) => {
          const id = `add_${i}`;
          switch (f.type) {
            case 'text':
              return (
                <div className="input" key={id}>
                  <label htmlFor={id}>{f.title}{f.is_required ? ' *' : ''}</label>
                  <textarea id={id} className="input__text" rows={2} value={f.value || ''} onChange={(e) => this.setVal(i, e.target.value)} />
                </div>
              );
            case 'select':
              return (
                <div className="input" key={id}>
                  <label htmlFor={id}>{f.title}{f.is_required ? ' *' : ''}</label>
                  <select id={id} className="input__text" value={f.value || f.default_value || ''} onChange={(e) => this.setVal(i, e.target.value)}>
                    {(f.values || []).map((v, vi) => (<option key={vi} value={v}>{v}</option>))}
                  </select>
                </div>
              );
            case 'boolean':
              return (
                <label className="checkbox" key={id}>
                  <input type="checkbox" checked={!!f.value} onChange={(e) => this.setVal(i, e.target.checked)} />
                  <span className="checkbox__title">{f.title}{f.is_required ? ' *' : ''}</span>
                </label>
              );
            case 'string':
            default:
              return (
                <div className="input" key={id}>
                  <label htmlFor={id}>{f.title}{f.is_required ? ' *' : ''}</label>
                  <input id={id} className="input__text" type="text" value={f.value || ''} onChange={(e) => this.setVal(i, e.target.value)} />
                </div>
              );
          }
        })}
      </section>
    );
  }
}

export const AdditionalFields = observer(AdditionalFieldsView, ['orderStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/Checkout/AdditionalFields.jsx